(function() {
  angular
  .module('meanApp')
  .factory('measuresManager', measuresManager);

  measuresManager.$inject = ["Measure", "modelManager"];
  function measuresManager (Measure, modelManager) {
		return angular.extend({}, modelManager.init(Measure));
  };

})();